export const createLegalProvisionDocumentService =
  (fetch) => async (legalProvisionDocument) => {
    try {
      const response = await fetch({
        url: "/api/v1/siniestros-viales/documentos-provisiones-legales",
        method: "post",
        body: legalProvisionDocument,
        contentType: "multipart/form-data",
      });

      return response;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  };
